// layouts/AuthLayout.tsx
// import background_print from '_assets/images/background_print_01.png';
import main_logo from '_assets/logos/main_logo.png';
import React from 'react';
import { Link } from 'react-router-dom';
import snowflake from '../assets/snowflake.png';
import Navbar from './components/Navbar';

// Snowflake component
const Snowflake: React.FC<{
  size: string;
  opacity: string;
  animation: string;
  duration: string;
  left: string;
  color: string;
}> = ({ size, opacity, animation, duration, left, color }) => (
  <div
    className={`absolute ${size} ${opacity} z-0`}
    style={{
      animation: `${animation} ${duration} linear infinite`,
      left,
      top: '0px',
    }}
  >
    <div className={`w-full h-full ${color} rounded-full shadow-sm`}></div>
  </div>
);

// Image Snowflake component
const ImageSnowflake: React.FC<{
  size: string;
  opacity: string;
  animation: string;
  duration: string;
  left: string;
}> = ({ size, opacity, animation, duration, left }) => (
  <div
    className={`absolute ${size} ${opacity} z-0`}
    style={{
      animation: `${animation} ${duration} linear infinite`,
      left,
      top: '0px',
    }}
  >
    <img
      src={snowflake}
      alt="snowflake"
      className="w-full h-full object-contain"
    />
  </div>
);

// Skater component
const Skater: React.FC<{
  size: string;
  opacity: string;
  animation: string;
  duration: string;
  bottom: string;
  color: string;
}> = ({ size, opacity, animation, duration, bottom, color }) => (
  <div
    className={`absolute ${size} ${opacity} z-0`}
    style={{
      animation: `${animation} ${duration} linear infinite`,
      bottom,
    }}
  >
    <div className={`w-full h-full ${color} rounded-full shadow-sm`}></div>
  </div>
);

// Snowflake configuration data
const snowflakeConfig = [
  {
    size: 'w-4 h-4',
    opacity: 'opacity-80',
    animation: 'snowfall-1',
    duration: '8s',
    left: '10%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-2 h-2',
    opacity: 'opacity-60',
    animation: 'snowfall-2',
    duration: '12s',
    left: '20%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-5 h-5',
    opacity: 'opacity-90',
    animation: 'snowfall-3',
    duration: '6s',
    left: '35%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-3 h-3',
    opacity: 'opacity-70',
    animation: 'snowfall-4',
    duration: '10s',
    left: '50%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-4 h-4',
    opacity: 'opacity-85',
    animation: 'snowfall-5',
    duration: '7s',
    left: '65%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-2 h-2',
    opacity: 'opacity-65',
    animation: 'snowfall-1',
    duration: '11s',
    left: '80%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-3 h-3',
    opacity: 'opacity-75',
    animation: 'snowfall-2',
    duration: '9s',
    left: '15%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-2.5 h-2.5',
    opacity: 'opacity-80',
    animation: 'snowfall-3',
    duration: '13s',
    left: '30%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-5 h-5',
    opacity: 'opacity-95',
    animation: 'snowfall-4',
    duration: '5s',
    left: '45%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-2 h-2',
    opacity: 'opacity-55',
    animation: 'snowfall-5',
    duration: '14s',
    left: '60%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-4 h-4',
    opacity: 'opacity-90',
    animation: 'snowfall-1',
    duration: '8.5s',
    left: '75%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-3 h-3',
    opacity: 'opacity-70',
    animation: 'snowfall-2',
    duration: '10.5s',
    left: '90%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-2 h-2',
    opacity: 'opacity-50',
    animation: 'snowfall-3',
    duration: '9.5s',
    left: '25%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-3 h-3',
    opacity: 'opacity-75',
    animation: 'snowfall-4',
    duration: '7.5s',
    left: '40%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-1.5 h-1.5',
    opacity: 'opacity-60',
    animation: 'snowfall-5',
    duration: '11.5s',
    left: '55%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-4 h-4',
    opacity: 'opacity-85',
    animation: 'snowfall-1',
    duration: '6.5s',
    left: '70%',
    color: 'bg-[#e6f0f5]',
  },
  {
    size: 'w-2.5 h-2.5',
    opacity: 'opacity-70',
    animation: 'snowfall-2',
    duration: '12.5s',
    left: '85%',
    color: 'bg-[#e6f0f5]',
  },
];

// Image Snowflake configuration data
const imageSnowflakeConfig = [
  {
    size: 'w-6 h-6',
    opacity: 'opacity-70',
    animation: 'snowfall-1',
    duration: '9s',
    left: '5%',
  },
  {
    size: 'w-4 h-4',
    opacity: 'opacity-60',
    animation: 'snowfall-2',
    duration: '13s',
    left: '15%',
  },
  {
    size: 'w-7 h-7',
    opacity: 'opacity-80',
    animation: 'snowfall-3',
    duration: '7s',
    left: '25%',
  },
  {
    size: 'w-5 h-5',
    opacity: 'opacity-65',
    animation: 'snowfall-4',
    duration: '11s',
    left: '40%',
  },
  {
    size: 'w-3 h-3',
    opacity: 'opacity-75',
    animation: 'snowfall-5',
    duration: '8s',
    left: '55%',
  },
  {
    size: 'w-6 h-6',
    opacity: 'opacity-70',
    animation: 'snowfall-1',
    duration: '12s',
    left: '70%',
  },
  {
    size: 'w-4 h-4',
    opacity: 'opacity-60',
    animation: 'snowfall-2',
    duration: '10s',
    left: '85%',
  },
  {
    size: 'w-5 h-5',
    opacity: 'opacity-80',
    animation: 'snowfall-3',
    duration: '14s',
    left: '95%',
  },
];

// Skater configuration data
const skaterConfig = [
  {
    size: 'w-8 h-8',
    opacity: 'opacity-15',
    animation: 'skate-figure-1',
    duration: '12s',
    bottom: '20%',
    color: 'bg-blue-100',
  },
  {
    size: 'w-6 h-6',
    opacity: 'opacity-12',
    animation: 'skate-figure-2',
    duration: '10s',
    bottom: '30%',
    color: 'bg-indigo-100',
  },
  {
    size: 'w-7 h-7',
    opacity: 'opacity-14',
    animation: 'skate-figure-3',
    duration: '14s',
    bottom: '15%',
    color: 'bg-slate-100',
  },
  {
    size: 'w-5 h-5',
    opacity: 'opacity-10',
    animation: 'skate-figure-4',
    duration: '8s',
    bottom: '35%',
    color: 'bg-blue-50',
  },
  {
    size: 'w-6 h-6',
    opacity: 'opacity-13',
    animation: 'skate-figure-5',
    duration: '11s',
    bottom: '25%',
    color: 'bg-indigo-50',
  },
  {
    size: 'w-4 h-4',
    opacity: 'opacity-08',
    animation: 'skate-figure-6',
    duration: '9s',
    bottom: '40%',
    color: 'bg-blue-50',
  },
  {
    size: 'w-7 h-7',
    opacity: 'opacity-16',
    animation: 'skate-figure-7',
    duration: '13s',
    bottom: '12%',
    color: 'bg-indigo-100',
  },
  {
    size: 'w-5 h-5',
    opacity: 'opacity-11',
    animation: 'skate-figure-8',
    duration: '7s',
    bottom: '28%',
    color: 'bg-slate-50',
  },
  {
    size: 'w-6 h-6',
    opacity: 'opacity-14',
    animation: 'skate-figure-9',
    duration: '15s',
    bottom: '18%',
    color: 'bg-blue-100',
  },
  {
    size: 'w-4 h-4',
    opacity: 'opacity-09',
    animation: 'skate-figure-10',
    duration: '6s',
    bottom: '32%',
    color: 'bg-indigo-50',
  },
  {
    size: 'w-8 h-8',
    opacity: 'opacity-17',
    animation: 'skate-figure-11',
    duration: '16s',
    bottom: '8%',
    color: 'bg-slate-100',
  },
  {
    size: 'w-5 h-5',
    opacity: 'opacity-12',
    animation: 'skate-figure-12',
    duration: '10.5s',
    bottom: '22%',
    color: 'bg-blue-50',
  },
  {
    size: 'w-6 h-6',
    opacity: 'opacity-13',
    animation: 'skate-figure-13',
    duration: '12.5s',
    bottom: '38%',
    color: 'bg-indigo-100',
  },
  {
    size: 'w-4 h-4',
    opacity: 'opacity-10',
    animation: 'skate-figure-14',
    duration: '8.5s',
    bottom: '16%',
    color: 'bg-slate-50',
  },
  {
    size: 'w-7 h-7',
    opacity: 'opacity-15',
    animation: 'skate-figure-15',
    duration: '11.5s',
    bottom: '26%',
    color: 'bg-blue-100',
  },
];

const AuthLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="flex h-[calc(100vh-var(--qa-banner-offset,0px))] bg-cover bg-center bg-gray-50 bg-no-repeat relative overflow-hidden">
      {/* Snowflakes */}
      {snowflakeConfig.map((config, index) => (
        <Snowflake key={index} {...config} />
      ))}

      {/* Image Snowflakes */}
      {imageSnowflakeConfig.map((config, index) => (
        <ImageSnowflake key={`img-${index}`} {...config} />
      ))}

      {/* Skating Figures */}
      {skaterConfig.map((config, index) => (
        <Skater key={`skater-${index}`} {...config} />
      ))}
      <Navbar />

      {/* Main Content */}
      <div className="flex flex-col flex-grow relative z-10">
        <div
          className="flex items-center justify-center h-[calc(100vh-var(--qa-banner-offset,0px))] px-4"
          // style={{
          //   // backgroundImage: `url(${background_print})`,
          //   // backgroundColor: 'rgba(0, 0, 0, 0.8)', // Adding a dark overlay
          //   backgroundBlendMode: 'overlay',
          // }}
        >
          <div className="bg-white/90 backdrop-blur-sm shadow-md w-full max-w-sm sm:max-w-md">
            {' '}
            {/* Made the white background slightly transparent */}
            <div className="flex justify-center py-4 bg-white px-4">
              <Link to="/">
                <img
                  src={main_logo}
                  alt="logo"
                  className="h-16 me-3 cursor-pointer"
                />
              </Link>
            </div>
            <div className="px-4 py-4">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
